<script lang="ts" setup>
    import { useNavigationStore } from '@/js/stores/navigation';

    const navigation = useNavigationStore();
</script>

<template>
    <h2 v-if="navigation.visible" class="text-gray-dark/50 mt-6 mb-3">
        <slot />
    </h2>
    <div v-else class="my-4 border-t border-gray-lightest"></div>
</template>
